import { createQueryKeyStore } from '@lukemorales/query-key-factory'

import { isNotUndefined } from '@hcr/utils'

export const keys = createQueryKeyStore({
  accommodations: {
    all: (resortId?: number) => [
      {
        ...(isNotUndefined(resortId) && { resortId }),
      },
    ],
    details: (accommodationId: number) => [accommodationId],
  },
  countries: {
    all: null,
  },
  history: {
    all: null,
    accommodation: (accommodationId: number) => [accommodationId],
  },
  onboarding: {
    user: (nonce: string) => [nonce],
  },
  singleTickets: {
    all: (resortsIds?: number[]) => [
      {
        ...(isNotUndefined(resortsIds) && { resortsIds }),
      },
    ],
  },
  user: {
    details: null,
  },
})
